module.exports = __webpack_public_path__ + "assets/img/apple.7a620c72.png";